/**
 * Detects webpack lazy-chunk load failures.
 *
 * A real ChunkLoadError (thrown by the webpack runtime when a deployed bundle references a chunk
 * that no longer exists on the server after a new release) sets `error.name === "ChunkLoadError"`
 * while its `message` is "Loading chunk <id> failed.\n(error: <url>)" — the message does NOT contain
 * the substring "ChunkLoadError". Checking only the message therefore never matches the real error,
 * so users never got the "reload for new code" prompt and the errors flooded Bugsnag instead.
 *
 * We check `name` (the reliable signal), keep the legacy message-substring check for safety, and
 * also match the "Loading chunk … failed" message pattern as a belt-and-suspenders fallback.
 *
 * Kept free of Angular imports so it can be unit-tested directly (the jest preset used by this lib
 * does not transform Angular's ESM bundles).
 */
export function isChunkLoadError(error: any): boolean {
  if (!error) return false;
  const name = typeof error.name === "string" ? error.name : "";
  const message = typeof error.message === "string" ? error.message : "";
  return name === "ChunkLoadError" || message.indexOf("ChunkLoadError") > -1 || /Loading chunk .* failed/i.test(message);
}
